/* tslint:disable */
/* eslint-disable */
export enum TimeDuration {
  Years = 'Years',
  Months = 'Months',
  Weeks = 'Weeks',
  Days = 'Days',
  Hours = 'Hours'
}
